module.exports = __webpack_public_path__ + "static/landing-image-1-0a920f135ecccc7bbe13ec195fe321de.png";